<template>
  <DefaultLayout v-if="showLayout">
    <router-view />
  </DefaultLayout>
  <router-view v-else />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'

const route = useRoute()
const showLayout = computed(() => route.meta?.layout !== 'none')
</script>
